module.exports = __webpack_public_path__ + "img/gouqi.703e678b.png";